import React from "react"
import PropTypes from "prop-types"

import {Document, Page, StyleSheet, Font} from "@react-pdf/renderer"
import Header from "./delivery_note/Header"
import Table from "./delivery_note/Table"

const styles = StyleSheet.create({
  page: {
    padding: 30,
    display: "flex",
    flexDirection: "column"
  }
})

Font.register({
  family: "Roboto",
  src: "https://fonts.gstatic.com/s/roboto/v16/zN7GBFwfMP4uA6AR0HCoLQ.ttf"
})

const DeliveryNote = ({number, stock_outs, tenantName}) => {
  const title = `delivery_note_${number}.pdf`

  return (
    <Document title={title}>
      <Page style={styles.page} size="A4" orientation="portrait">
        <Header tenantName={tenantName} />
        <Table number={number} stock_outs={stock_outs} />
      </Page>
    </Document>
  )
}

export default DeliveryNote

DeliveryNote.propTypes = {
  number: PropTypes.string.isRequired,
  tenantName: PropTypes.string.isRequired,
  stock_outs: PropTypes.array.isRequired
}



// WEBPACK FOOTER //
// ./src/components/pdf/DeliveryNote.js